export interface LoginState {
  isLoading: boolean
  isPreviousSessionOpen: boolean
  currentStep: 'LOGIN' | 'VERIFY_CODE'
  credentials: Credentials
}

export type LoginStep = LoginState['currentStep']
export type Credentials = {
  email: string
  password: string
}

export const initialState: LoginState = {
  isLoading: false,
  isPreviousSessionOpen: false,
  currentStep: 'LOGIN',
  credentials: {
    email: '',
    password: ''
  }
}
